import * as React from "react";

import { Loading } from "../../Common";

import { useForgotPasswordForm } from "../providers";

export const AppLoading: React.FunctionComponent = () => {
  const { isLoading: isResetPasswordApiLoading } = useForgotPasswordForm();

  const isLoading = React.useMemo(() => {
    return isResetPasswordApiLoading;
  }, [isResetPasswordApiLoading]);

  if (!isLoading) {
    return null;
  }

  return <Loading />;
};
